import type { ReactNode } from "react";

/**
 * The one key/value block.
 *
 * The same job used to be described three different ways on three detail
 * screens: a label-above grid, a `<dl>` with a 6rem left column, and a tight
 * stack of `.label-sm` pairs. A definition list is what this is, so it is one.
 */
export interface SpecItem {
  label: string;
  value: ReactNode;
  /** Hidden entirely when the value is absent, rather than printing a dash. */
  when?: boolean;
}

export function SpecList({
  items,
  columns = false,
  className = "",
}: {
  items: readonly SpecItem[];
  /** Side-by-side from 600px up, for short values (rate, area, category). */
  columns?: boolean;
  className?: string;
}) {
  const visible = items.filter((item) => item.when !== false);
  if (visible.length === 0) return null;

  return (
    <dl className={`spec-list${columns ? " spec-list--columns" : ""} ${className}`.trim()}>
      {visible.map((item) => (
        <div key={item.label}>
          <dt>{item.label}</dt>
          <dd>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
